import type { ProductItem } from '../types';
import { usePreviewTheme } from './PreviewTheme';

interface ProductIntroSectionProps {
  items: ProductItem[];
}

// 可截断的文本（最多两行）
function TruncatedText({
  text,
  maxLines = 2,
  className = '',
  useRich = false,
}: {
  text: string;
  maxLines?: number;
  className?: string;
  useRich?: boolean;
}) {
  const style: React.CSSProperties = {
    display: '-webkit-box',
    WebkitLineClamp: maxLines,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
  };

  if (useRich) {
    return (
      <div
        className={`rich-text-preview ${className}`}
        style={style}
        dangerouslySetInnerHTML={{ __html: text }}
      />
    );
  }

  return (
    <div className={className} style={style} title={text}>
      {text}
    </div>
  );
}

export default function ProductIntroSection({ items }: ProductIntroSectionProps) {
  const theme = usePreviewTheme();

  if (!items || items.length === 0) {
    return null;
  }

  const handleJump = (link?: string) => {
    if (!link) return;
    if (/^https?:\/\//.test(link)) {
      window.open(link, '_blank');
    } else {
      window.location.href = link;
    }
  };

  return (
    <div>
      {/* 标题区域 */}
      <div className="px-4 py-3 border-b border-gray-100 flex items-center">
        <div className="flex items-center gap-2 flex-1">
          <h3 className="text-base font-bold" style={{ color: theme.textHighlightColor }}>产品介绍</h3>
          <p className="text-xs text-gray-400 tracking-widest ml-1">PRODUCT INTRODUCTION</p>
        </div>
      </div>

      {/* 产品列表 - 上图下文 */}
      <div className="p-4 space-y-3">
        {items.map((item) => (
          <div
            key={item.id}
            className="rounded-xl overflow-hidden hover:shadow-lg transition-all duration-200 group bg-white border border-gray-100"
          >
            {/* 上图区域（高度缩小） */}
            <div className="h-28 bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center relative overflow-hidden">
              {item.image ? (
                <img
                  src={item.image}
                  alt={item.title}
                  className="max-w-full max-h-full object-contain group-hover:scale-102 transition-transform duration-300"
                />
              ) : (
                <span className="text-5xl opacity-30">📦</span>
              )}
            </div>

            {/* 下文区域 */}
            <div className="p-3">
              {/* 标题 - 两行省略 */}
              <TruncatedText
                text={item.title}
                maxLines={2}
                className="text-sm font-semibold text-gray-800 mb-1.5"
              />

              {/* 描述 - 两行省略（支持富文本） */}
              {/* <TruncatedText
                text={item.description}
                maxLines={2}
                className="text-[11px] text-gray-600 leading-relaxed mb-2 min-h-[30px]"
                useRich
              /> */}

              {/* 右下角查看全部按钮 - 跳转 */}
              {/* <div className="flex justify-end">
                <button
                  onClick={() => handleJump(item.link)}
                  className="text-[11px] text-blue-500 hover:text-blue-600 flex items-center gap-0.5 transition-colors"
                >
                  查看全部
                  <span>→</span>
                </button>
              </div> */}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
